export const handleSearchAddress = async ({ action, navigate }) => {
  const searchInput = document.querySelector(
    '[data-sherlock-id="search-transactions-input"]'
  );

  if (searchInput) {
    const searchString = action.params.address;
    searchInput.value = searchString;

    // Dispatch custom search event
    const searchEvent = new CustomEvent('sherlock-event-1', {
      detail: { searchString },
      bubbles: true,
    });
    searchInput.dispatchEvent(searchEvent);
  }

  return null;
};

